import { ConfigurationLocalAccountingBillableClientsModalRulesItem } from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rules/configuration-local-accounting-billable-clients-modal-rules.model'
import { BillableRateResponse } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/configuration-local-accounting-billable-rates/billable-rate.dto'
import { StrictNullable } from '@/shared/types/app.types'

export interface ConfigurationLocalAccountingCustomerRateGridBasicFormState {
    id: StrictNullable<number>
    casePhysicalCenterForAutoAssignment: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesItem>
    caseRegimeForAutoAssignment: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesItem>
    casePriorityForAutoAssignment: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesItem>
    caseInsurerForAutoAssignment: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesItem>
    priorityForAutomaticAssignment: StrictNullable<number>
    isForAutoInvoice: StrictNullable<boolean>
    selectedRate: StrictNullable<BillableRateResponse>
}
export const initialLocalAccountingCustomerRatesGridBasicFormState =
    (): ConfigurationLocalAccountingCustomerRateGridBasicFormState => ({
        id: null,
        selectedRate: null,
        isForAutoInvoice: false,
        casePhysicalCenterForAutoAssignment: null,
        caseRegimeForAutoAssignment: null,
        casePriorityForAutoAssignment: null,
        caseInsurerForAutoAssignment: null,
        priorityForAutomaticAssignment: 1
    })
